import React from 'react';

interface GeneratedTextIconProps {
  size?: number;
  className?: string;
}

/**
 * iOS-style "generated text" glyph: stacked text lines with a sparkle marker.
 */
export const GeneratedTextIcon: React.FC<GeneratedTextIconProps> = ({
  size = 24,
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
  >
    <path d="M6.5 7.5h9.5" />
    <path d="M6.5 11.5h7" />
    <path d="M6.5 15.5h8.5" />
    <path
      d="M16.75 5.25l.45 1.35 1.35.45-1.35.45-.45 1.35-.45-1.35-1.35-.45 1.35-.45.45-1.35z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export default GeneratedTextIcon;
